<template>
	<div class="qualification">
		<div class="center_box">
			<h1 class="title">荣誉资质</h1>
			<h2 class="en_title">QUALIFICATIONS</h2>
			<div class="lantern">
				<div ref="lantern" class="items">
					<div v-for="v in data" :key="v.id" class="item" :class="{'item_1': v.sizeType == 1,'item_2': v.sizeType == 2}">
						<viewer :images="[v.pictureUrl]">
							<img :src="v.pictureUrl" alt="">
						</viewer>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			data: {
				type: Array,
				default() { return []; }
			}
		},
		mounted() {
			this.interval = null;
			this.offsetWidth = this.$refs.lantern.offsetWidth;
			this.step = 1;
			this.step_time = 10;
			this.offsetLeft = 0;
			this.runAnimationByItem() && this.runAnimation();
			this.addEvents();
		},
		beforeDestroy() {
			this.interval && clearInterval(this.interval);
			this.removeEvents();
		},
		methods: {
			/******************** @Events ********************/
			
			/******************** @Function ********************/
			// 根据item的数量判断是否进行走马灯
			runAnimationByItem() {
				let bool = false;
				this.data.length > 4 && (bool = true);
				return bool;
			},
			// 开始走马灯
			runAnimation() {
				this.interval = setInterval(() => {
					this.offsetLeft--;
					Math.abs(this.offsetLeft) >= this.offsetWidth && (this.offsetLeft = 1200);
					this.$refs.lantern.style.left = this.offsetLeft + 'px';
				}, this.step_time);
			},
			// 添加事件
			addEvents() {
				this.$refs.lantern.addEventListener('mouseenter', this.mouseenter, false);
				this.$refs.lantern.addEventListener('mouseleave', this.mouseleave, false);
			},
			// 移除事件
			removeEvents() {
				this.$refs.lantern.removeEventListener('mouseenter', this.mouseenter, false);
				this.$refs.lantern.removeEventListener('mouseleave', this.mouseleave, false);
			},
			mouseenter() {
				this.interval && clearInterval(this.interval);
			},
			mouseleave() {
				this.runAnimation();
			}
		}
	}
</script>

<style scoped>
	.qualification{ padding: 90px 0 130px 0;background: #f1f4fb; }
	.qualification .center_box{ width: 1200px;margin: 0 auto; }
	.qualification .title{ font-size: 30px;font-weight: bold;text-align: center;line-height: 42px; }
	.qualification .en_title{ font-size: 24px;color: #ccc;text-align: center;line-height: 34px; }
	.qualification .lantern{ display: block;position: relative;width: 1200px;height: 322px;margin-top: 50px;overflow: hidden; }
	.qualification .lantern .items{ display: block;position: absolute;height: 100%;top: 0;left: 0;white-space: nowrap; }
	.qualification .lantern .item{ display: inline-block;margin: 0 31px;padding: 6px 6px 7px 7px;vertical-align: middle;cursor: pointer; }
	.qualification .lantern .item_1{ width: 322px;height: 238px;background-image: url(../../../../assets/qualification_border_column.png);background-size: 100% 100%; }
	.qualification .lantern .item_2{ width: 238px;height: 322px;background-image: url(../../../../assets/qualification_border_column.png);background-size: 100% 100%; }
	.qualification .lantern .item_1 img{ display: block;width: 309px;height: 225px; }
	.qualification .lantern .item_2 img{ display: block;width: 225px;height: 309px; }
</style>
